import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getBlogCategories } from "../../../../store/actions/councilActions/blogAction";
import { setCenterBlogAccess } from "../../../../store/actions/councilActions/centerActions";

/*
  Grant / change a centre's blog posting access straight from the centre list.
  `center` is the row; onSaved(updated) lets the list refresh the status.
*/
const BlogAccessModal = ({ center, onHide, onSaved }) => {
  const dispatch = useDispatch();
  const [allow, setAllow] = useState(false);
  const [cats, setCats] = useState({});
  const [catList, setCatList] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    dispatch(getBlogCategories(false)).then((l) => setCatList(l || []));
  }, [dispatch]);

  useEffect(() => {
    if (!center) return;
    setAllow(Number(center.blog_access) === 1);
    const pre = {};
    String(center.blog_categories || "")
      .split(",")
      .filter(Boolean)
      .forEach((id) => (pre[Number(id)] = true));
    setCats(pre);
  }, [center]);

  const save = async () => {
    setBusy(true);
    const allowedCats = Object.keys(cats)
      .filter((c) => cats[c])
      .map((c) => Number(c));
    const res = await dispatch(
      setCenterBlogAccess({
        id: center.id,
        blog_access: allow ? 1 : 0,
        blog_categories: allowedCats,
      })
    );
    setBusy(false);
    if (res) {
      onSaved && onSaved(center.id, allow ? 1 : 0, allowedCats);
      onHide();
    }
  };

  return (
    <Modal show={!!center} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Blog Access{center?.center_name ? ` - ${center.center_name}` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="mb-2" style={{ cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={allow}
            onChange={() => setAllow((v) => !v)}
          />{" "}
          Allow Blog Posting
        </label>

        {allow && (
          <div
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "8px",
              maxHeight: "220px",
              overflowY: "auto",
            }}
          >
            <small className="text-muted d-block mb-1">
              Categories this centre may post in:
            </small>
            {catList.length === 0 ? (
              <div>No blog categories found.</div>
            ) : (
              catList.map((c) => (
                <label
                  key={c.id}
                  className="mb-0 d-block"
                  style={{ cursor: "pointer", padding: "2px 0" }}
                >
                  <input
                    type="checkbox"
                    checked={!!cats[c.id]}
                    onChange={() =>
                      setCats((s) => ({ ...s, [c.id]: !s[c.id] }))
                    }
                  />{" "}
                  {c.name}
                </label>
              ))
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={save} disabled={busy}>
          {busy ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default BlogAccessModal;
